import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import { useNavigate } from 'react-router-dom';
import NewRoom from './NewRoom';


const Rooms = () => {
    const { isSidebarOpen } = useSidebar();
    const navigate = useNavigate();
      const BASE_URL = process.env.REACT_APP_API_BASE_URL;



    const [searchQuery, setSearchQuery] = useState('');
    const [rooms, setRooms] = useState([]);
    const [filteredRooms, setFilteredRooms] = useState(rooms);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const filtered = rooms.filter((room) =>
            Object.values(room).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredRooms(filtered);
        setCurrentPage(1);
    }, [searchQuery, rooms]);


    useEffect(() => {
        const fetchRooms = async () => {
            try {
                const res = await fetch(`${BASE_URL}/api/rooms`); // ✅ replace with your real API
                if (!res.ok) throw new Error("Failed to fetch rooms");
                const data = await res.json();
                console.log('Fetched rooms:', data);  // <--- add this to check data shape

                setRooms(data);
            } catch (err) {
                console.error("Error fetching rooms:", err);
            }
        };

        fetchRooms();
    }, []);


    const totalPages = Math.ceil(filteredRooms.length / itemsPerPage);
    const currentData = filteredRooms.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this room?")) return;

        try {
            const res = await fetch(`${BASE_URL}/api/rooms/${id}`, {
                method: "DELETE",
            });

            if (!res.ok) {
                throw new Error("Failed to delete room");
            }

            // Remove from UI
            setRooms((prevRooms) => prevRooms.filter((room) => room.id !== id));
        } catch (err) {
            console.error("Delete error:", err);
            alert("Failed to delete room.");
        }
    };


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Posted Rooms</h1>
                    <button className="oms-add-btn" onClick={() => navigate("/new-room-posting")}>
                        Add New Room
                    </button>
                </div>

                {/* Search */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search rooms..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                {/* Room Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Address</th>
                                <th>City</th>
                                <th>State</th>
                                <th>Price</th>
                                <th>Discounted</th>
                                <th>Type</th>
                                <th>Features</th>
                                <th>Amenities</th>
                                <th>Room Rules</th>
                                <th>Guest Preferences</th>
                                <th>Service Charge</th>
                                <th>GST</th>
                                <th>Posted On</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((room, index) => (
                                    <tr key={index}>
                                        <td>{room.title}</td>
                                        <td>{room.description}</td>
                                        <td>{room.address}</td>
                                        <td>{room.city}</td>
                                        <td>{room.state}</td>
                                        <td>{room.originalPrice}</td>
                                        <td>{room.discountedPrice}</td>
                                        <td>{room.propertyType}</td>
                                        <td>{Array.isArray(room.keyFeatures) ? room.keyFeatures.join(", ") : "-"}</td>
                                        <td>{Array.isArray(room.amenities) ? room.amenities.join(", ") : "-"}</td>
                                        <td>
                                            {Array.isArray(room.roomRules) ? (
                                                room.roomRules.join(", ")
                                            ) : (
                                                <div dangerouslySetInnerHTML={{ __html: room.roomRules || "-" }} />
                                            )}
                                        </td>
                                        <td>{Array.isArray(room.guestPreferences) ? room.guestPreferences.join(", ") : "-"}</td>
                                        <td>{room.additionalCharge}</td>
                                        <td>{room.gstPercentage}</td>
                                        <td>{room.postedOn}</td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => navigate(`/edit-room/${room.id}`)}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>


                                            <button className="delete-button" onClick={() => handleDelete(room.id)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="16" style={{ textAlign: 'center' }}>No rooms found.</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>

        </>
    );
};

export default Rooms;
